import {createReducer, on} from "@ngrx/store";
import {TeamInfoState} from "@team/pages/infos/store/team-info.state";
import {TeamInfoActions} from './team-info.actions-type';
import {CoreEnvironmentService} from "@core/services/environment/core-environment.service";

function getInitialInfosState(): TeamInfoState {
  const env = CoreEnvironmentService.getEnvironment();
  return {
    infoList: [],
    paging: {
      totalItems: 0,
      pageNumber: 0,
      pageSize: env?.apiUrl?.pageDefaultSize || 1,
      totalPages: 1
    },
    isLoading: true,
    isLoadingId: NaN
  }
}

export const teamInfoStore = createReducer(
  getInitialInfosState(),
  on(TeamInfoActions.getInfoList, (state) => ({
    ...state,
    isLoading: true
  })),
  on(TeamInfoActions.getInfoListCancel, (state) => ({
    ...state,
    isLoading: false
  })),
  on(TeamInfoActions.getInfoListSuccess, (state, { data }) => ({
    ...state,
    infoList: data.paging.pageNumber === 1 ? [...data.items] : [...state.infoList, ...data.items],
    paging: data.paging,
    isLoading: false
  })),
  on(TeamInfoActions.getInfoListFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(TeamInfoActions.getInfoListRefresh, (state, { data }) => ({
    ...state,
    infoList: [...data.items],
    paging: data.paging,
    isLoading: false
  })),
  on(TeamInfoActions.postItemsMyRead, (state, data) => ({
    ...state,
    isLoading: false,
    isLoadingId: data.id
  })),
  on(TeamInfoActions.postItemsMyReadSuccess, (state, { updatedItems, data }) => ({
      ...state,
      infoList: updatedItems,
      isLoadingId: undefined,
      isLoading: false
    })
  ),
  on(TeamInfoActions.postItemsMyReadFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(TeamInfoActions.postItemsMyReadFail, (state) => ({
    ...state,
    isLoading: false
  }))
);
